import React, { Component } from 'react';
import Formsy from 'formsy-react';
import {
  withStyles,
  Button,
  InputAdornment,
  Icon,
  Box,
  IconButton,
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import { TextFieldFormsy } from '../../../../@fuse';
import * as Actions from '../../../../auth/store/actions';
import history from '../../../../history';
import '../../../../styles/customizations.css';
import packageJson from '../../../../../package.json';
import * as FuseActions from '../../../../store/actions';

const styles = () => ({
  root: {
    width: '100%',
  },
});

class JWTLoginTab extends Component {
  form = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      validationErrors: null,
      showPassword: false,
      loading: false,
      credentials: null,
      messageText: null,
      messageType: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { login, clearLoginError } = this.props;
    // quando 2FA é sinalizado, encerramos o loading para mostrar o campo
    if (
      login?.twoFactorRequired &&
      prevProps?.login?.twoFactorRequired !== login.twoFactorRequired
    ) {
      this.setState({ loading: false });
      this.handleMessage(
        'Enviamos um código de acesso para seu email. Verifique sua caixa de entrada.',
        'success'
      );
    }

    // 2FA falhou ao enviar
    if (login.error && login.error.message === '2FA_SEND_FAILED') {
      this.setState({ loading: false });
      this.handleMessage(
        'Falha ao enviar o código de verificação. Tente novamente em instantes.',
        'error'
      );
      clearLoginError();
      return;
    }

    // Falha na segunda etapa (código incorreto/expirado)
    if (
      login.error &&
      (login.error.message === 'INVALID_2FA_CODE' ||
        login.error.message === '2FA_EXPIRED')
    ) {
      this.setState({ loading: false });
      this.handleMessage(
        'Codigo de verificação incorreto, realize o login novamente para enviarmos um novo código.',
        'error'
      );
      clearLoginError();
      return;
    }

    // Falha na primeira etapa (credenciais)
    if (login.error && (login.error.email || login.error.password)) {
      this.setState({ loading: false });
      this.handleToastMessage('Erro ao realizar login, verifique suas credenciais', 'error');
      clearLoginError();
    }

    if (login.success) {
      this.setState({ loading: false });
      history.push({ pathname: '/account/list' });
    }
  }

  // Mensagens de feedback (banner)
  handleMessage = (text, type = 'info') => {
    this.setState({ messageText: text, messageType: type });
  };

  handleToastMessage = (message, variant) => {
    const { showMessage } = this.props;

    showMessage({
      message,
      autoHideDuration: 6000,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
      },
      variant,
    });
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => {
      const next = !prevState.showPassword;
      return { showPassword: next };
    });
  };

  onSubmit = (model) => {
    const { submitLogin, submitLogin2FA, login } = this.props;
    const { email, password, code } = model;

    // 2ª etapa primeiro: não validar campos desmontados
    if (login && login.twoFactorRequired) {
      const { credentials } = this.state;
      const emailToUse = credentials?.email;
      const passwordToUse = credentials?.password;

      if (!code) {
        this.form.updateInputsWithError({ code: 'Informe o código!' });
        return false;
      }

      if (!emailToUse || !passwordToUse) {
        this.setState({
          validationErrors: 'Sessão inválida. Refaça o login.',
        });
        return false;
      }

      submitLogin2FA({
        email: emailToUse,
        password: passwordToUse,
        code,
      });
      return true;
    }

    // 1ª etapa
    if (!email) {
      this.form.updateInputsWithError({ email: 'Informe o usuário!' });
      return false;
    }
    if (!password) {
      this.form.updateInputsWithError({ password: 'Informe a senha!' });
      return false;
    }

    this.setState({
      loading: true,
      validationErrors: null,
      credentials: { email, password },
      messageText: null,
      messageType: null,
    });
    submitLogin({ email, password });
    return true;
  };

  handleChange = (event) => {
    if (event && event.target) {
      this.setState({
        validationErrors: null,
        messageText: null,
        messageType: null,
      });
    } else if (event && event.name) {
      this.setState({
        validationErrors: null,
        messageText: null,
        messageType: null,
      });
    }
  };

  render() {
    const { classes, login } = this.props;
    const {
      validationErrors,
      showPassword,
      loading,
      messageText,
      messageType,
    } = this.state;
    const { version } = packageJson;

    const hideCreds = loading || login?.twoFactorRequired;

    return (
      <div className={classes.root}>
        <Formsy
          onValidSubmit={this.onSubmit}
          onChange={this.handleChange}
          ref={(form) => {
            this.form = form;
          }}
          className="flex flex-col justify-center w-full"
        >
          {!hideCreds && (
            <>
              <TextFieldFormsy
                className="login-input"
                type="text"
                name="email"
                label="Username/Email"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Icon className="text-20" color="action">
                        email
                      </Icon>
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
                required
                style={{ marginBottom: '15px' }}
                onChange={this.handleChange}
              />

              <TextFieldFormsy
                className="login-input"
                type={showPassword ? 'text' : 'password'}
                name="password"
                label="Password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={this.togglePasswordVisibility}
                      >
                        <Icon className="text-20" color="action">
                          {showPassword ? 'visibility' : 'visibility_off'}
                        </Icon>
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
                required
                onChange={this.handleChange}
              />
            </>
          )}

          {login?.twoFactorRequired && (
            <TextFieldFormsy
              className="login-input"
              type="text"
              name="code"
              label="Código enviado em seu e-mail"
              variant="outlined"
              required
              inputProps={{
                maxLength: 6,
                inputMode: 'numeric',
                pattern: '[0-9]*',
              }}
              onChange={this.handleChange}
            />
          )}

          {validationErrors && (
            <div style={{ color: 'red' }}>{validationErrors}</div>
          )}

          {messageText && (
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: 10,
                marginBottom: 10,
                padding: '8px 12px',
                borderRadius: 4,
                color: messageType === 'success' ? '#1b5e20' : '#b71c1c',
                background: messageType === 'success' ? '#e8f5e9' : '#ffebee',
              }}
            >
              <Icon
                className="text-20"
                color="action"
                style={{ marginRight: 8 }}
              >
                {messageType === 'success' ? 'check_circle' : 'error'}
              </Icon>
              <span style={{ fontSize: 14 }}>{messageText}</span>
            </Box>
          )}

          {loading && (
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <CircularProgress size={20} style={{ marginRight: 8 }} />
              <span style={{ fontSize: 14 }}>
                Aguardando envio do código de confirmação para seu e-mail...
              </span>
            </Box>
          )}

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="w-full mx-auto mt-16 normal-case"
            aria-label="LOG IN"
            style={{ marginTop: '10px', marginBottom: '10px' }}
            value="legacy"
            disabled={loading}
          >
            {login?.twoFactorRequired ? 'Confirmar código' : 'Login'}
          </Button>
          <a
            style={{ marginTop: '10px', marginBottom: '10px' }}
            href="https://api.smarteklife.com/oauth/amazon"
            target="_blank"
            rel="noreferrer"
          >
            Login Amazon
          </a>
        </Formsy>
        <Box style={{ marginTop: 50, textAlign: 'center' }}>
          <span style={{ fontSize: '12px' }}>Versão: {version}</span>
        </Box>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      submitLogin: Actions.submitLogin,
      clearLoginError: () => ({ type: Actions.LOGIN_ERROR, payload: null }),
      submitLogin2FA: Actions.submitLogin2FA,
      showMessage: (options) => dispatch(FuseActions.showMessage(options)),
    },
    dispatch
  );
}

function mapStateToProps({ auth }) {
  return {
    login: auth.login,
    user: auth.user,
  };
}

export default withStyles(styles, { withTheme: true })(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(JWTLoginTab))
);
